<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BlU8D/tc-custom/scover.jpg" alt="This image is the cover for the book Bettie Page Vol. 1: Bettie In Hollywood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bettie Page Vol. 1: Bettie In Hollywood
      </h1>
      <p class="bookDescription body article font2">
        <p>She's more modest than Ms. Blaise, but peels more than Ms. Emma. She out-vamps Vampirella, but she's sweeter than Honey West. She put the mod in model, and the bangs in bang-bang. Now the world can know the truth: her classified adventures back in 1951 Hollywood have been declassified. Dynamite, David Avallone and Colton Worley are proud to present The Secret Diary of Bettie Page, in handy comic book form. This volume collects Issues 1-4 of Bettie Page and an exclusive short story illustrated by Joseph Michael Linsner, originally published in Playboy Magazine, with an introduction by writer David Avallone.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Avallone
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dynamite Entertainment
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42942f39